import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Typography, Space } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import api from '../api/client';

const { Title } = Typography;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values: { password: string }) => {
    setLoading(true);
    try {
      await api.post('/auth/admin/login', { password: values.password });
      localStorage.setItem('admin_authenticated', 'true');
      navigate('/');
    } catch {
      message.error('비밀번호가 올바르지 않습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f5f5f5',
    }}>
      <Card style={{ width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={3} style={{ margin: 0, color: '#1677ff' }}>
            KMHC
          </Title>
          <p style={{ color: '#999', marginTop: 8 }}>관리자 로그인</p>
        </div>
        <Form onFinish={handleLogin}>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '비밀번호를 입력해주세요.' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="관리자 비밀번호"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              로그인
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Space split={<span style={{ color: '#d9d9d9' }}>|</span>}>
            <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: '#999', fontSize: 12 }}>Terms of Service</a>
            <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#999', fontSize: 12 }}>Privacy Policy</a>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default Login;
